module.exports = __webpack_public_path__ + "static/media/gameVideo1.be23522e.mp4";